module.exports = __webpack_public_path__ + "img/full3-min.647cb8c6.png";